import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TEAM } from '../../../../core/constants/team';

@Component({
  selector: 'app-nuestro-equipo',
  templateUrl: './nuestro-equipo.component.html',
  styleUrls: ['./nuestro-equipo.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class NuestroEquipoComponent implements OnInit {
  personas = TEAM;

  constructor() { }

  ngOnInit(): void {

  }

}
